import { makeStyles } from "@material-ui/core/styles";
import { useStateValue } from "../context/state/provider";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import BackIcon from "../images/backIcon.svg";
import { VIEW } from "../constants/view.constants";

function detectIframe() {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

const useStyles = makeStyles({
	avatar: (props) => ({
		backgroundImage: props.avatarUrl ? `url("${props.avatarUrl}")` : "var(--active-avatar-url)",
		backgroundPosition: "center",
		backgroundSize: "cover",
		backgroundColor: "var(--color-alt-grey)",
		borderRadius: "14px",
		height: props.isEmbedded ? "42px" : "48px",
		width: props.isEmbedded ? "42px" : "48px",
		marginRight: "12px",
		flexShrink: 0,
		border: "1px solid var(--surface-border)",
		boxShadow: "0 1px 2px rgba(15,23,42,0.06)",
		animation: "fadeIn 0.25s ease",
	}),
	backButton: {
		borderRadius: "12px",
		height: "42px",
		width: "42px",
		marginRight: "10px",
		"& img": {
			filter: "brightness(0) saturate(100%) invert(18%)",
		},
		"&:hover": {
			background: "rgba(15, 23, 42, 0.05)",
		},
	},
	flexRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		minWidth: 0,
	},
	titleBlock: {
		minWidth: 0,
		textAlign: "left",
	},
	botStatus: {
		color: "var(--bot-status)",
		fontSize: "11px",
		margin: "0 0 0 8px",
		flexShrink: 0,
	},
	botTitle: (props) => ({
		fontFamily: "var(--font-sans)",
		fontSize: props.isEmbedded ? "15px" : "18px",
		fontWeight: 700,
		letterSpacing: "-0.03em",
		lineHeight: 1.2,
		margin: 0,
		maxWidth: "100%",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		textAlign: "left",
		color: "var(--color-dark-grey)",
	}),
	accessibilityTitle: {
		fontFamily: "var(--font-sans)",
		fontSize: "17px",
		fontWeight: 700,
		letterSpacing: "-0.02em",
		textAlign: "left",
		margin: 0,
		color: "var(--color-dark-grey)",
	},
	subTitle: {
		fontFamily: "var(--font-sans)",
		fontSize: "12.5px",
		margin: "3px 0 0",
		fontWeight: 500,
		lineHeight: 1.35,
		textAlign: "left",
		color: "var(--color-muted)",
		maxWidth: "100%",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
});

export default function HeaderTitle({ brandingTitle, subtitle, avatarUrl }) {
	const isEmbedded = detectIframe();
	const classes = useStyles({ avatarUrl, isEmbedded });
	const [{ view }, dispatch] = useStateValue();

	const handleBackButton = () => {
		dispatch({
			type: "SET_VIEW",
			view: VIEW.CHATROOM,
		});
	};

	return (
		<div className={classes.flexRow}>
			{view === VIEW.CHATROOM ? (
				<div className={classes.avatar} role="img" aria-label="Avatar" />
			) : (
				<Tooltip title="Back">
					<IconButton className={classes.backButton} onClick={handleBackButton}>
						<img src={BackIcon} alt="Back" />
					</IconButton>
				</Tooltip>
			)}
			{view === VIEW.CHATROOM && (
				<div className={classes.titleBlock}>
					<div className={classes.flexRow}>
						<h2 className={classes.botTitle}>{brandingTitle || "Assistant"}</h2>
						<FiberManualRecordIcon className={classes.botStatus} />
					</div>
					{subtitle ? (
						<p className={classes.subTitle}>{subtitle}</p>
					) : (
						<p className={classes.subTitle}>Internal assistant</p>
					)}
				</div>
			)}
			{view === VIEW.ACCESSIBILITY && (
				<h2 className={classes.accessibilityTitle}>Accessibility</h2>
			)}
			{view === VIEW.SETTINGS && (
				<h2 className={classes.accessibilityTitle}>Settings</h2>
			)}
			{view === VIEW.LOGIN && (
				<h2 className={classes.accessibilityTitle}>Sign in</h2>
			)}
		</div>
	);
}
